import type { ReactElement } from 'react';
import { Div, DivSkeleton } from '@fastnorth/kraken/components/layout';
import { onCourseSummaryRaceRowSkeletonSurfaceVariants } from './OnCourseSummaryRaceRowSkeleton.styles';

const OnCourseSummaryRaceRowSkeleton = (): ReactElement => (
  <Div
    className={onCourseSummaryRaceRowSkeletonSurfaceVariants()}
    data-testid="on-course-summary-race-row-skeleton">
    <DivSkeleton className="h-6 w-[12.5rem] max-w-[40%] rounded-lg" spacing="0 0" />
    <DivSkeleton className="h-7 w-full rounded-xl" spacing="0 0" />
    <Div className="flex w-full min-w-0 gap-x-10">
      {Array.from({ length: 3 }, (_, columnIndex) => (
        <Div key={columnIndex} className="flex w-[25%] min-w-0 flex-col gap-4">
          {Array.from({ length: 3 }, (_, barIndex) => (
            <DivSkeleton
              key={barIndex}
              className={`rounded-lg ${barIndex === 1 ? 'h-7 w-[35%]' : 'h-4 w-[55%]'}`}
              spacing="0 0"
            />
          ))}
        </Div>
      ))}
    </Div>
  </Div>
);

export default OnCourseSummaryRaceRowSkeleton;
